module.exports = __webpack_public_path__ + "img/20190820135359310.535a2cbf.png";